import React, { createContext, useContext, useState, useEffect } from 'react';
import adminAPI from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = adminAPI.getToken();
    const stored = adminAPI.getAdmin();
    if (token && stored) {
      setAdmin(stored);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await adminAPI.login(email, password);
    setAdmin(data.admin);
    return data;
  };

  const logout = () => {
    adminAPI.clearToken();
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, isAuthenticated: !!admin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export default AuthContext;
